<template>
<div class="inner-wrapper add-customer-section">
   <!--<div class="page-title">
     <h1 class="float-left">Task Details</h1>
   </div>-->
    <div class="row">
            <div class="col-md-12">
                <div class="card panel create-box">
                <div  class="card-header headnbtn">
                    <div  class="d-flex align-items-center justify-content-between">
                        <h5  class="card-title mb-0 flex-grow-1">Details</h5>
                    </div>
                </div>
                <div class="card-body">
                    <div class="view-customer-hed">
                        <div class="view-customer-icon"></div>
                        <span class="view-rght-txt active-txt"></span>
                    </div>
                    <div class="left-blk">
                        <div class="product-details-list">
                        <div class="alert alert-danger alert-dismissible" v-if="errorMessage !=null">
                                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                                <strong class="success_msg">{{errorMessage}}</strong>
                            </div>
                            <div class="alert alert-success succ_msg" v-if="successMessage">
                                <strong class="success_msg">{{successMessage}}</strong>
                            </div>
                        <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                            <ul>
                                <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                {{ error }}
                                </p>
                                </li>
                            </ul>
                        </div>
                            <div class="product-details-list">

                                <div class="product-des">
                                    <h5 class="card-title">Task Name :</h5>
                                    <p class="product-no">{{customerData.title}}</p>
                                </div>
                                <div class="product-des">
                                    <h5 class="card-title">Task Details :</h5>
                                    <p class="product-no">{{customerData.details}}</p>
                                </div>
                                <div class="product-des">
                                    <h5 class="card-title">Assigned to :</h5>
                                    <p class="product-no">{{customerData.assignee_name ? customerData.assignee_name.name : ''}}</p>
                                </div>
                                <div class="product-des">
                                    <h5 class="card-title">Due Date :</h5>
                                    <p class="product-no">{{formatDate(customerData.due_date)}}</p>
                                </div>
                                <template v-for="(taskAttachment, index) in customerData.task_attachment">
                                    <div class="product-des">

                                    <a :href="'task_files/'+taskAttachment.file_name" download><i class="fa fa-download"></i>{{taskAttachment.file_name}}</a>

                                    </div>
                                </template>
                                <template v-for="(taskNote, index) in customerData.task_note">
                                    <div class="product-des">

                                            <h5  class="cmpny-text">{{taskNote.assignee_name ? taskNote.assignee_name.name : ''}}</h5> <p> {{taskNote.description}}</p>

                                    </div>
                                </template>
                                <template v-for="(taskNote, index) in customerData.task_note">
                                    <div class="product-des">

                                            <h5  class="cmpny-text">{{taskNote.assignee_name ? taskNote.assignee_name.name : ''}}</h5> <p> {{taskNote.description}}</p>

                                    </div>
                                </template>
                                <div class="product-des last-child">
                                    <h5 class="card-title">Task Note :</h5>
                                    <textarea placeholder="" class="form-control" name="task_note" v-model="form.task_note" v-on:keyup.enter="saveNote" ></textarea>
                                </div>


                            </div>
                            <div class="btnrow2"><button type="button" @click="markComplete" class="btn btn-primary">Mark Complete</button></div>
                        </div>
                    </div>
                </div>
                </div>
            </div>

        </div>
        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

export default {
    name: "TaskView",
    created() {
        this.setCommonErrors([]);
        this.setErrorMessage(null);
        this.setSuccessMessage(null);
        this.getCustomer();
    },
    data(){
        return {
            customerData: {
                customer: null,
                country_data: null,
                customer_contact: null,
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null,
                task_attachment:[],
                task_note:[],
            },
            form:{
                task_note:null,
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        getCustomer() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('tasks.show', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                         this.customerData= data.data;
                         console.log("check datatttttt ",this.customerData.assignee_name);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        saveNote(){
            if(this.form.task_note != null){
                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.post(window.route('tasks.save-note',{id: this.$route.params.id}), this.form,{
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                       this.form.task_note = null;
                        //self.setSuccessMessage(data.message);
                       //$('#createVendor').modal('hide');
                       this.getCustomer();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
            }

        },
        markComplete(){

                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                this.setSuccessMessage(null);
                return axios.post(window.route('tasks.mark-complete',{id: this.$route.params.id}), this.form,{
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                       this.form.task_note = null;
                        self.setSuccessMessage(data.data);
                       //$('#createVendor').modal('hide');
                       this.getCustomer();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });

        },
        getSLNo(index) {
            return Number(this.customerData.config['start_from']) + index;
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
